/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-10 16:22:10
 */

import ParamsLog from '../paramsLog';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import ParamsLogApi, { ParamsLogDOI } from '../api/paramsLogApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import DatePicker from 'src/types/iview/DatePicker';
import EnumEntity from 'src/enums/enumEntity';
import EnumParamsLogType from 'src/enums/enumParamsLogType';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import FileUtil from 'src/util/fileUtil';

export default class ParamsLogService extends ListPageService {
    ctx: ParamsLog;

    constructor(ctx: ParamsLog) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '时间',
                field: 'datatime',
                minWidth: 170,
            },
            {
                headerName: '参数类型',
                field: 'parameter_type',
                minWidth: 100,
                cellRenderer(params) {
                    let data = params.data;
                    return EnumParamsLogType.findId(data.parameter_type).getName();
                },
            },
            {
                headerName: '日志内容',
                field: 'content',
                minWidth: 190,
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: EntitySelect,
                label: '组分',
                field: 'component',
                labelWidth: 60,
                width: 160,
                props: { value: null, type: EnumEntity.Component.getId(), searchParams: { mn: this.ctx.$route.query.mn } },
            },
            {
                component: CommonSelect,
                label: '参数类型',
                field: 'parameter_type',
                labelWidth: 60,
                width: 160,
                props: { value: '', dataSource: EnumParamsLogType.getList() },
            },

            {
                component: DatePicker,
                label: '时间',
                field: 'time',
                labelWidth: 60,
                width: 250,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: {
                    value: DateTimeUtil.getDayInterval(7),
                    type: 'daterange',
                    options: {
                        shortcuts: [
                            {
                                text: '最近1天',
                                value() {
                                    return DateTimeUtil.getDayInterval(1);
                                },
                            },
                            {
                                text: '最近7天',
                                value() {
                                    return DateTimeUtil.getDayInterval(7);
                                },
                            },
                            {
                                text: '最近30天',
                                value() {
                                    return DateTimeUtil.getDayInterval(30);
                                },
                            },
                        ],
                    },
                    placeholder: '请选择时间',
                },
            },
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '导出',
                type: 'info',
                async onClick() {
                    let { code, data } = await ParamsLogApi.exportAll(t.ctx.queryForm.getQueryObj<ParamsLogDOI.QueryRowDataParamsI>());
                    if (code === 0) {
                        FileUtil.download(data.download_url);
                    }
                },
            },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<ParamsLogDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await ParamsLogApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
            mn: this.ctx.$route.query.mn
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
